import { render, staticRenderFns } from "./ApartmentCard.vue?vue&type=template&id=06cfbdf2&"
import script from "./ApartmentCard.vue?vue&type=script&lang=js&"
export * from "./ApartmentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports